<template>
  <div>
    <div class="page-title">New Content Section</div>
    <Form
      v-if="form"
      v-model="form"
      :submit="create"
      btnText="Add Content Section"
    />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.content-sections.page";
export default {
  components: { Form },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.ContentSection.new();
      this.form = data;
    },
    async create() {
      await this.$api.ContentSection.create(this.form);
      this.$router.push("/widgets/content-sections");
    },
  },
};
</script>

<style scoped lang="scss"></style>
